import React from 'react'

import ArrowIcon from 'core/components/icons/ArrowIcon'

const PressTable = props => {
  return (
    <table className="press-table">
      <thead className="press-table-head">
        <tr className="press-table-row mod-head">
          <th className="press-table-cell mod-head mod-type">Type</th>
          <th className="press-table-cell mod-head mod-title">Title</th>
          <th className="press-table-cell mod-head mod-organization">Organization</th>
          <th className="press-table-cell mod-head mod-date">Date</th>
          <th className="press-table-cell mod-head mod-view"></th>
        </tr>
      </thead>
      <tbody className="press-table-body">
        {props.items.map((item, index) => (
          <tr className="press-table-row mod-body" key={index}>
            <td
              className="press-table-cell mod-body mod-type mod-clickable"
              onClick={e => props.toggleFilter(e, item.fields.article_type.toLowerCase())}
            >
              {item.fields.article_type}
            </td>
            <td className="press-table-cell mod-body mod-title">
              <a className="press-table-link" href={item.fields.article_link} target="_blank">
                {item.post_title}
              </a>
            </td>
            <td className="press-table-cell mod-body mod-organization">{item.fields.outlet}</td>
            <td className="press-table-cell mod-body mod-date">{item.post_date}</td>
            <td className="press-table-cell mod-body mod-view">
              <a
                className="press-table-link mod-view"
                href={item.fields.article_link}
                target="_blank"
              >
                View
                <ArrowIcon />
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default PressTable
